class CountReducer {
  initialValue() {
    return 0;
  }

  reduce(result, value) {
    return result + 1;
  }
}

export default CountReducer;